import type { UploadFolder } from "@repo/fika-shared/src/upload-folder.js"
import { http } from "./http"

export async function uploadImage(file: File, folder: UploadFolder) {
  const formData = new FormData()
  formData.append("file", file)

  const folderString = folder.join("/")
  const response = await http(`/api/upload-image?folder=${folderString}`, {
    method: "POST",
    body: formData,
    credentials: "include",
  })

  if (!response.ok) {
    throw new Error(`image upload failed: ${response.statusText}`)
  }

  const json = (await response.json()) as {
    success: boolean
    error: string
    data: string
  }

  if (!json.success) {
    throw new Error(`image upload failed: ${json.error}`)
  }

  const url = json.data

  await new Promise<void>((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve()
    img.onerror = reject
    img.src = url
  })

  return url
}
